import { Screen } from '@modules/shared/services/window.service';

import { SliderBaseItemInterface } from '../interfaces/slider.interface';

export const GetResponsiveConfig = (ratio: number): { [key in Screen]?: SliderBaseItemInterface } => {
  if (ratio > 1.7) {
    return {
      [Screen.XXXS]: {
        inGrid: true,
        itemsToSlide: 1,
        itemsToShow: 1,
      },
      [Screen.XS]: {
        inGrid: true,
        itemsToSlide: 2,
        itemsToShow: 2,
      },
      [Screen.MD]: {
        inGrid: true,
        itemsToSlide: 3,
        itemsToShow: 3,
      },
    };
  } else if (ratio > 0.6) {
    return {
      [Screen.XXXS]: {
        inGrid: true,
        itemsToSlide: 1,
        itemsToShow: 1,
      },
      [Screen.XS]: {
        inGrid: true,
        itemsToSlide: 2,
        itemsToShow: 2,
      },
      [Screen.MD]: {
        inGrid: true,
        itemsToSlide: 3,
        itemsToShow: 3,
      },
      [Screen.LG]: {
        inGrid: true,
        itemsToSlide: 4,
        itemsToShow: 4,
      },
    };
  }
  return {
    [Screen.XXXS]: {
      inGrid: true,
      itemsToSlide: 1,
      itemsToShow: 1,
    },
    [Screen.XS]: {
      inGrid: true,
      itemsToSlide: 2,
      itemsToShow: 2,
    },
    [Screen.SM]: {
      inGrid: true,
      itemsToSlide: 3,
      itemsToShow: 3,
    },
    [Screen.MD]: {
      inGrid: true,
      itemsToSlide: 4,
      itemsToShow: 4,
    },
  };
};
